import { render } from "./vpublicnumcapital.vue?vue&type=template&id=06a9841d&scoped=true"
import script from "./vpublicnumcapital.vue?vue&type=script&lang=js"
export * from "./vpublicnumcapital.vue?vue&type=script&lang=js"

import "./vpublicnumcapital.vue?vue&type=style&index=0&id=06a9841d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a9841d"]])

export default __exports__